
import { DBStatRecord, DbStatsSearch, DBStatsService } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";

export interface DbStatsOptions extends ControllerOptions<DBStatRecord> {
    filter?: DbStatsSearch
}


export class ClientDbStatsService extends BaseClientService implements DataController<DBStatRecord> {

    private _service: DBStatsService;


    constructor() {
        super();
        this._service = new DBStatsService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


    public async get(options: DbStatsOptions) {
        let fetchParams = this.buildFetchParams(options)
        return await this._service.get(fetchParams, this.token, options.filter);
    }



}


